import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PipesModule } from '../../pipes/pipes.module';
import { RouterModule } from '@angular/router';
import { RentPaymentAssociationComponent } from './rent-payment-association-selector.component';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        PipesModule,        
    ],
    declarations: [
        RentPaymentAssociationComponent
    ],
    exports: [
        RentPaymentAssociationComponent
    ]
})

export class RentPaymentAssociationModule {
}
